import { Injectable } from '@angular/core';

@Injectable()
export class FormErrorsService {

    public validationMessages = {
        "email": {
            "required": "Field is required",
            "maxlength": "Maxlength 255 character",
            "emailValidator": "Error format email",
            "percentValidator": "Field can't contain a character %",
            "pattern": 'Please, enter valid value'
        },
        "password": {
            "required": "Field is required",
            "minlength": "Minlength 8 numbers",
            "maxlength": "Maxlength 32 numbers",
        },
        "name": {
            "required": "Field is required",
            "maxlength": "Maxlength 70 character",
            "percentValidator": "Field can't contain a character %",
            "pattern": 'Please, enter valid value'
        },
        "phone": {
            "required": "Field is required",
            "maxlength": "Maxlength 15 numbers",
            "minlength": "Minlength 10 numbers",
        },
        "location": {
            "required": "Field is required",
            "maxlength": "Maxlength 175 character",
            "percentValidator": "Field can't contain a character %",
            "pattern": 'Please, enter valid value'
        },
    };

    constructor() {}

    public getErrors(form, errors) {
        if (!form) return;

        for ( const field in errors ) {
            errors[field] = '';
            const control = form.get(field);

            if (control && control.touched) {
                const message = this.validationMessages[field];
                for (const key in control.errors) {
                    errors[field] += message[key] + ' ';
                }
            }
        }
        return errors;
    }
}


// WEBPACK FOOTER //
// C:/www/onetouchSuperAdmin/src/app/form-errors.service.ts